import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(cadastros, periodoInicial, periodoFinal, situacao) {
  let title_pdf = 'Desempenho por microárea'
  let titlePdfSave = utils.methods.titlePdf('Desempenho por microárea')

  let description_pdf = 'Percentual de visitas realizadas por grupo e período'
  let headers_pdf = [
    'ORDEM',
    'UBS',
    'INE',
    'MICROÁREA',
    'ACS/TACS',
    'RESULTADO',
    'VISITADAS',
    'CADASTRADAS',
  ]

  const dataPdf = cadastros.map((item, i) => {
    const prof =
      item.profissionalSelected && item.profissionalSelected != ''
        ? item.profissionalSelected
        : Array.isArray(item.profissionais) && item.profissionais.length == 1
        ? item.profissionais[0]
        : ''

    return {
      ordem: `${i + 1}º`,
      no_unidade_saude: item.no_unidade_saude,
      nu_ine: item.nu_ine,
      nu_micro_area: item.nu_micro_area,
      acs_tacs: prof,
      resultado: item.resultado != null ? `${item.resultado}%` : '',
      visitadas: item.visitadas,
      cadastradas: item.cadastradas,
    }
  })

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Período inicial',
            value: periodoInicial.split('-').reverse().join('/'),
          },
          {
            label: 'Período final',
            value: periodoFinal.split('-').reverse().join('/'),
          },
          {
            label: 'Grupo',
            value: situacao.label,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  UBS: 'no_unidade_saude',
  INE: {
    field: 'nu_ine',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  Microárea: {
    field: 'nu_micro_area',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  'ACS/TACS': {
    callback: (item) => {
      let prof =
        item.profissionalSelected && item.profissionalSelected != ''
          ? item.profissionalSelected
          : Array.isArray(item.profissionais) && item.profissionais.length == 1
          ? item.profissionais[0]
          : ''
      return prof
    },
  },
  Visitadas: 'visitadas',
  Cadastradas: 'cadastradas',
  Resultado: {
    field: 'resultado',
    callback: (value) => {
      return value != null ? `${value}%` : ''
    },
  },
}
